// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Accreditation_wrap__1ng1j"};